export default __webpack_public_path__ + "86f319c601f31239147acadad316c475.svg";